import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './main.component';
import { AuthGuard } from '../guards/auth.guard';

const routes: Routes = [
    {
        path: '',
        canLoad: [AuthGuard],
        data: { breadcrumb: {skip: true}},
        component: MainComponent,
        children: [
            {
                path: '',
                redirectTo: 'activeAlerts',
                canLoad: [AuthGuard],
                pathMatch: 'full',
            },
            {
                path: 'account',
                data: {
                    breadcrumb: 'account'
                },
                loadChildren: () => import('./account/account.module').then(m => m.AccountModule),
                canActivate: [AuthGuard]
            },
            {
                path: 'account-owner',
                data: {
                    breadcrumb: 'account'
                },
                loadChildren: () => import('./account-owner/account-owner.module').then(m => m.AccountOwnerModule),
                canActivate: [AuthGuard]
            },
            {
                path: 'activeAlerts',
                data: { breadcrumb: 'activeAlerts' },
                loadChildren: () => import('./alert/alert.module').then(m => m.AlertModule),
                canActivate: [AuthGuard],
            },
            {
                path: 'alertHistory',
                data: { breadcrumb: 'alertHistory' },
                loadChildren: () => import('./alert-history/alert-history.module').then(m => m.AlertHistoryModule),
                canActivate: [AuthGuard]

            },
            {
                path: 'generalInfo',
                data: { breadcrumb: 'generalInfo' },
                loadChildren: () => import('./general-info/general-info.module').then(m => m.GeneralInfoModule),
                canActivate: [AuthGuard]
            },
            {
                path: 'notifications',
                data: { breadcrumb: 'notifications' },
                loadChildren: () => import('./notification/notification.module').then(m => m.NotificationModule),
                canActivate: [AuthGuard]
            },
            {
                path: 'users',
                data: { breadcrumb: 'users' },
                loadChildren: () => import('./user-management/user-management.module').then(m => m.UserManagementModule),
                canActivate: [AuthGuard]
            },
            {
                path: 'reports',
                data: { breadcrumb: 'reports' },
                loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule),
                canActivate: [AuthGuard]
            },
            {
                path: 'settings',
                data: { breadcrumb: 'settings' },
                loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule),
                canActivate: [AuthGuard]
            },
            {
                path: 'userProfile',
                data: { breadcrumb: 'userProfile' },
                loadChildren: () => import('./user-profile/user-profile.module').then(m => m.UserProfileModule),
                canActivate: [AuthGuard]
            },
            {
                path: 'changePassword',
                data: { breadcrumb: 'changePassword' },
                loadChildren: () => import('./change-password/change-password.module').then(m => m.ChangePasswordModule),
                canActivate: [AuthGuard]
            },
            {
                path: 'edit-profile-picture',
                data: {
                    breadcrumb: 'editPicture'
                },
                loadChildren: () => import('./change-picture/change-picture.module').then(m => m.ChangePictureModule),
                canActivate: [AuthGuard]
            }
        ]
    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainRoutingModule { }

